import { signingCollectionReviewerSchema, signingDtoOutputSchema } from './signings.js';
import { z } from './utils/zod.js';
import { successResponse, errorResponse, dataResponse } from './utils/response-templates.js';
export const signingReviewStatusSchema = z.object({
    status: z.string(),
    reviewer: signingCollectionReviewerSchema,
});
export const signingReviewSigningSchema = signingDtoOutputSchema.omit({ reviewers: true });
export const signingReviewResponseSchema = z.object({
    reviewerId: z.string(),
    status: z.enum(['PENDING', 'APPROVED', 'REJECTED']),
    reviewers: z.array(signingReviewStatusSchema),
    signing: signingReviewSigningSchema,
});
export const getSigningReviewResponseSchema = dataResponse(signingReviewResponseSchema);
export const signingReviewNotFoundResponseSchema = errorResponse('Signing review not found');
export const signingNotInReviewResponseSchema = errorResponse('Signing is not in review state');
export const signingReviewAlreadyApprovedResponseSchema = errorResponse('Review already approved');
export const signingReviewAlreadyRejectedResponseSchema = errorResponse('Review already rejected');
export const approveSigningReviewResponseSchema = successResponse();
export const rejectSigningReviewResponseSchema = successResponse();
export const reviewerStatusSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    status: z.enum(['PENDING', 'APPROVED', 'REJECTED']),
    reviewedAt: z.string().datetime().nullable(),
});
export const signingReviewStatusResponseSchema = z.object({
    pending: z.boolean(),
    reviewers: z.array(reviewerStatusSchema),
});
export const getSigningReviewStatusResponseSchema = dataResponse(signingReviewStatusResponseSchema);
